import type { ProductAnalyticsArea } from "@/lib/analytics/productAnalytics"

export const normalizeAnalyticsPath = (pathname: string): string => {
  const normalized = `/${pathname}`.replace(/\/+/g, "/").replace(/\/+$/, "").toLowerCase()
  return normalized || "/"
}

export const getAnalyticsAreaForPath = (pathname: string): ProductAnalyticsArea => {
  const path = normalizeAnalyticsPath(pathname)

  if (path === "/") return "other"
  if (path === "/login" || path === "/reset-password" || path === "/confirm-email") {
    return "auth"
  }
  if (path === "/profile") return "profile"
  if (path === "/events" || /^\/events\/[^/]+$/.test(path)) return "events"
  if (path === "/deposits" || /^\/deposits\/[^/]+$/.test(path)) return "deposits"
  if (path === "/projects" || /^\/projects\/[^/]+$/.test(path)) return "projects"
  if (path === "/portal/events" || path.startsWith("/portal/events/")) return "events"
  if (path === "/portal/deposit" || path.startsWith("/portal/deposit/")) return "deposits"
  if (path === "/portal/projects" || path.startsWith("/portal/projects/")) return "projects"
  return "other"
}
